var ProductPlpCampaigns = {
  PRODUCTS_AS_VSIN: [],
  init: function() {
    $('.product-card:not([data-checked])').each(function () {
      ProductPlpCampaigns.PRODUCTS_AS_VSIN.push($(this).data('product-sku'));
  
      $(this).attr('data-checked', true);
    });
  
    if(ProductPlpCampaigns.PRODUCTS_AS_VSIN.length > 0) {
      ProductPlpCampaigns.getProducts(ProductPlpCampaigns.PRODUCTS_AS_VSIN);
    }
  },
  getProducts: function(vsins) {
    var apiBaseUrl = '';
  
    switch(window.CAMPAIGNS_ENV) {
      case 'production':
        apiBaseUrl = 'https://api.vivense.com/';
      break;
      case 'staging':
        apiBaseUrl = 'https://api-staging.vivense.com/';
      break;
      case 'sandbox':
        apiBaseUrl = 'https://api-sandbox.vivense.com/';
      break;
      case 'test':
      default:
        apiBaseUrl = 'https://api-test.vivense.com/';
      break;
    }
  
    var chunkSize = 32;
    var chunkedVsins = [];
  
    for (var i = 0; i < vsins.length; i += chunkSize) {
      chunkedVsins.push(vsins.slice(i, i + chunkSize));
    }
  
    for(var i = 0; i < chunkedVsins.length; i++) {
      $.ajax({
        type: 'GET',
        url: apiBaseUrl + 'products/listing/search' + '?page=0&where=vsin:' + chunkedVsins[i].join(','),
        success: function (response) {
            var products = response && response.items && Array.isArray(response.items) && response.items.length > 0 ? response.items : [];
            
            products = products
              .map(function (product) {
                var promotionBadges = [];
                
                if(product.promotionBadges && Array.isArray(product.promotionBadges) && product.promotionBadges.length > 0) {
                  promotionBadges = product.promotionBadges;
                  promotionBadges = promotionBadges.filter(function (promotionBadge) {
                    return promotionBadge.basketPrice && promotionBadge.basketPrice > 0;
                  });
                }
  
                return {
                  vsin: product.vsin,
                  promotionBadges: promotionBadges
                };
              })
              .filter(function (product) {
                return product.promotionBadges.length > 0;
              });
            
              ProductPlpCampaigns.setPromotionBadges(products);
        }
      });
    }
  },
  setPromotionBadges: function(products) {
    for(var i = 0; i < products.length; i++) {
      var vsin = products[i].vsin;
      var promotionBadge = products[i].promotionBadges.length > 0 ? products[i].promotionBadges[0] : null;
  
      if(promotionBadge) {
        var campaignContanier = $('.product-card-campaigns[data-product-sku="' + vsin + '"]');
        campaignContanier.empty();
        campaignContanier.append('<div class="product-card-campaigns__item text-danger">Sepette: ' + parseInt(promotionBadge.basketPrice).toLocaleString('tr-TR') + ' TL</div>');
      }
    }
  }
};

$(document).ready(ProductPlpCampaigns.init);